import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeEn from '@angular/common/locales/en';
import localeHu from '@angular/common/locales/hu';
import localeLt from '@angular/common/locales/lt';
import localeLv from '@angular/common/locales/lv';
import localeNb from '@angular/common/locales/nb';
import localePl from '@angular/common/locales/pl';
import localeRu from '@angular/common/locales/ru';
import localeSq from '@angular/common/locales/sq';
import localeSv from '@angular/common/locales/sv';
import localeTr from '@angular/common/locales/tr';
import localeUk from '@angular/common/locales/uk';
import { Language } from '@app/shared/types/enums/language.type';

const APP_LOCALES: readonly { data: object; localeId: Language }[] = [
  { data: localeDa, localeId: Language.DA },
  { data: localeEn, localeId: Language.EN },
  { data: localeHu, localeId: Language.HU },
  { data: localeLt, localeId: Language.LT },
  { data: localeLv, localeId: Language.LV },
  { data: localeNb, localeId: Language.NB },
  { data: localePl, localeId: Language.PL },
  { data: localeRu, localeId: Language.RU },
  { data: localeSq, localeId: Language.SQ },
  { data: localeSv, localeId: Language.SV },
  { data: localeTr, localeId: Language.TR },
  { data: localeUk, localeId: Language.UK }
];

/** Registers Angular locale data for every {@link Language} supported by the app. */
export function registerAppLocales(): void {
  for (const { data, localeId } of APP_LOCALES) {
    registerLocaleData(data, localeId);
  }
}
